var progress = function() {

    var string = '<div class="progress">' +
        '<div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;">' +
        '0%' +
        '</div>'  +
        '</div> ';

    return $.parseHTML(string);
}

module.exports = progress;




//////////////////
// WEBPACK FOOTER
// ./src/exam_parts/progress.js
// module id = 230
// module chunks = 0